import { render } from "./totalCount.vue?vue&type=template&id=5187a39e&scoped=true"
import script from "./totalCount.vue?vue&type=script&lang=js"
export * from "./totalCount.vue?vue&type=script&lang=js"

import "./totalCount.vue?vue&type=style&index=0&id=5187a39e&lang=scss&scoped=true"

import exportComponent from "/usr/local/apps/meng/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5187a39e"]])

export default __exports__